/**
 * Shared colors for 2D canvas and 3D viewer so drawn items appear the same in both.
 * All values are CSS hex strings; Three.js accepts these in MeshBasicMaterial.
 */

import type { SurfaceKey, TeePositionColorKey, PinDay } from './types';

export const SURFACE_COLORS: Record<SurfaceKey, string> = {
  secondCut: '#224020',
  firstCut: '#2d5228',
  fairway: '#2d5a27',
  green: '#4a7c2c',
  fringe: '#5a8c35',
  bunker: '#c4a574',
  waste: '#6b5344',
  water: '#4a90c4',
  cartPath: '#6b6b6b',
  outOfBounds: '#ffffff',
  hazard: '#cc0000',
};

export const TEE_BOX_FILL = '#3d6b2f';
export const TEE_BOX_STROKE = '#5a8c35';
export const TREE_COLOR = '#1a4d1a';
export const HOUSE_COLOR = '#4a4a4a';
export const PIN_COLOR = '#c41e3a';

export const PIN_DAY_COLORS: Record<PinDay, string> = {
  thu: '#c41e3a',
  fri: '#ffffff',
  sat: '#2563eb',
  sun: '#eab308',
};

export function getPinColor(day: PinDay | undefined): string {
  return day ? PIN_DAY_COLORS[day] ?? PIN_COLOR : PIN_COLOR;
}

export const TEE_POSITION_COLORS: Record<TeePositionColorKey, string> = {
  red: '#c41e3a',
  gold: '#ffd700',
  white: '#ffffff',
  gray: '#808080',
  blue: '#2563eb',
  black: '#1a1a1a',
};

export const MARKER_150_COLOR = '#f0e68c';
export const GROUND_PLANE_COLOR = '#252525';

export function getTeePositionColor(key: TeePositionColorKey | undefined): string {
  return key ? TEE_POSITION_COLORS[key] ?? TEE_POSITION_COLORS.white : TEE_POSITION_COLORS.white;
}

/** Ensure every SurfaceKey has a color (for type safety). */
export function getSurfaceColor(key: SurfaceKey): string {
  return SURFACE_COLORS[key] ?? '#333';
}
